import React, { useState } from 'react'
import { Modal, Select, Button, Typography, Space } from 'antd'
import { Users } from '@a4b/api/src/modules/Monetisation/Offerings/types'
import { useAppContext } from '@/components/AppContext'

const { Option } = Select
const { Text } = Typography

interface BulkAssignModalProps {
    visible: boolean
    onClose: () => void
    onAssign: (payload: { batch_ids: string[], associate_id: string, editor_email: string }) => void
    hubAssociates: Users[]
    selectedBatches: any[]
}

const BulkAssignModal: React.FC<BulkAssignModalProps> = ({
    visible,
    onClose,
    onAssign,
    hubAssociates,
    selectedBatches
}) => {
    const [selectedAssociateId, setSelectedAssociateId] = useState<string>('')
    const { userProfile } = useAppContext();

    console.log("email", userProfile?.email);
    const handleAssign = () => {
        if (!selectedAssociateId) {
            return
        }
        const payload = {
            batch_ids: selectedBatches.map(batch => batch.batch_id),
            associate_id: selectedAssociateId,
            editor_email: userProfile?.email || ''
        };

        onAssign(payload)
        setSelectedAssociateId('')
    }

    const handleCancel = () => {
        setSelectedAssociateId('')
        onClose()
    }

    return (
        <Modal
            title="Bulk Assign Hub Associate"
            visible={visible}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button
                    key="assign"
                    type="primary"
                    onClick={handleAssign}
                    disabled={!selectedAssociateId}
                >
                    Assign
                </Button>,
            ]}
            width={500}
        >
            <Space direction="vertical" style={{ width: '100%' }} size="middle">

                <div>
                    <Text strong style={{ marginBottom: '8px' }}>Select Hub Associate:</Text>
                    <Select
                        value={selectedAssociateId}
                        onChange={setSelectedAssociateId}
                        style={{ width: '100%', marginTop: 8 }}
                        placeholder="Choose an associate to assign"
                    >
                        {hubAssociates?.map((associate: Users) => (
                            <Option key={associate.id} value={associate.id}>
                                {associate.name}
                                {associate.user_type === 'hub_manager' && (
                                    <span style={{ color: 'orange' }}> (Hub Manager)</span>
                                )}
                            </Option>
                        ))}
                    </Select>

                    <div style={{ marginTop: '16px' }}>
                        <Text >Selected Batches: </Text>
                        {selectedBatches.length > 0 && (
                            <ol>
                                {selectedBatches.map((batch: any) => {
                                    return (
                                        <li key={batch.batch_id}>
                                            {batch.batch_code}
                                        </li>
                                    )
                                })}
                            </ol>
                        )}
                    </div>
                </div>
            </Space>
        </Modal>
    )
}

export default BulkAssignModal